const AppID = {
  Awin: 'track-awin',
  Facebook: 'track-facebook',
  Tiktok: 'track-tiktok',
  Insurance: 'insurance',
  GiftCard: 'gift-card',
  NextDay: 'next-day',
} as const

export const buildAwinCustomData = (awc: string | null) => {
  return {
    customData: { ...(awc && { awc }), sourceIsAwin: 'true' as const },
    appId: AppID.Awin,
  }
}

export const buildFacebookCustomData = ({
  fbc,
  fbp,
}: {
  fbc: string | null
  fbp: string | null
}) => {
  return {
    customData: { ...(fbc && { fbc }), ...(fbp && { fbp }) },
    appId: AppID.Facebook,
  }
}

export const buildTiktokCustomData = ({ ttp }: { ttp: string | null }) => {
  return {
    customData: { ...(ttp && { ttp }) },
    appId: AppID.Tiktok,
  }
}

export const buildInsuranceCustomData = (data: string) => {
  return {
    customData: { data: data ?? '' },
    appId: AppID.Insurance,
  }
}

export const buildGiftCardCustomData = (giftCardInfo: {
  name?: string
  email?: string
  sender?: string
  message?: string
  faceImage?: string
  value?: string
}) => {
  const sender = giftCardInfo.sender?.trim()

  return {
    customData: {
      ...(giftCardInfo.name && { name: giftCardInfo.name }),
      ...(giftCardInfo.email && { email: giftCardInfo.email }),
      ...(sender && { sender }),
      ...(giftCardInfo.message && { message: giftCardInfo.message }),
      ...(giftCardInfo.faceImage && { faceImage: giftCardInfo.faceImage }),
      ...(giftCardInfo.value && { value: giftCardInfo.value }),
    },
    appId: AppID.GiftCard,
  }
}

export const buildNexDayCustomData = (isEligible: string) => {
  return {
    customData: {
      cartIsEligible: isEligible,
    },
    appId: AppID.NextDay,
  }
}
